// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kWvjb","label":"styles_label__EEqOl","value":"styles_value__VIySi"};